// extracted by css-extract-rspack-plugin
export default {"wrapper":"Q290vbu6vIcpCvL4","actionRow":"eSJfjN6jVlMjIfMF"};